module.exports = __webpack_public_path__ + "bc13caaa45e8cedc913c7a5322864c14.png";